import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/api/client";
import Layout from "@/components/Layout";
import Modal from "@/components/Modal";
import { toast } from "sonner";
import { IDS } from "@/constants/testIds";

const empty = { name: "", contact: "", phone: "", email: "", address: "", tax_code: "", team: "", note: "" };

export default function Clienti() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);

  const load = async () => {
    const r = await api.get("/customers"); setRows(r.data);
  };
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm(empty); setEditingId(null); setModal(true); };
  const openEdit = (c) => { setForm({ ...empty, ...c }); setEditingId(c.id); setModal(true); };
  const save = async () => {
    if (!form.name.trim()) return toast.error("Nome cliente richiesto");
    try {
      if (editingId) await api.put(`/customers/${editingId}`, form);
      else await api.post("/customers", form);
      toast.success("Cliente salvato"); setModal(false); load();
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  const del = async (id) => {
    if (!window.confirm("Eliminare il cliente?")) return;
    await api.delete(`/customers/${id}`); toast.success("Eliminato"); load();
  };

  const filtered = rows.filter((c) =>
    (c.name + " " + (c.team || "") + " " + (c.email || "") + " " + (c.tax_code || "")).toLowerCase().includes(q.toLowerCase())
  );

  return (
    <Layout topbarActions={
      <button className="btn accent" onClick={openNew} data-testid={IDS.newCustomerBtn}>
        <i className="fa-solid fa-plus" /> Nuovo cliente
      </button>
    }>
      <div className="section-title">
        <div><h2>Clienti</h2><p>Atleti, società, palestre e privati che acquistano da voi.</p></div>
      </div>
      <div className="panel">
        <div className="panel-head">
          <div className="toolbar">
            <input placeholder="Cerca nome, squadra, email o C.F..." value={q} onChange={(e) => setQ(e.target.value)} />
          </div>
          <button className="btn primary" onClick={openNew}><i className="fa-solid fa-plus" /> Aggiungi cliente</button>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Nome / Ragione sociale</th><th>Squadra / Società</th><th>Referente</th><th>Email</th><th>Telefono</th><th>Codice fiscale / P.IVA</th><th></th></tr></thead>
            <tbody data-testid="customers-table-body">
              {filtered.length ? filtered.map((c) => (
                <tr key={c.id}>
                  <td><b>{c.name}</b><br /><small style={{ color: "var(--muted)" }}>{c.address || ""}</small></td>
                  <td>{c.team || "—"}</td>
                  <td>{c.contact || "—"}</td>
                  <td>{c.email || "—"}</td>
                  <td>{c.phone || "—"}</td>
                  <td>{c.tax_code || "—"}</td>
                  <td style={{ display: "flex", gap: 6 }}>
                    <button className="btn small" onClick={() => openEdit(c)}><i className="fa-solid fa-pen" /></button>
                    <button className="btn small danger" onClick={() => del(c.id)}><i className="fa-solid fa-trash" /></button>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={7} className="empty">Nessun cliente trovato.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal open={modal} title={editingId ? "Modifica cliente" : "Nuovo cliente"} onClose={() => setModal(false)} onSave={save}>
        <div className="form-grid">
          <div className="field full"><label>Nome / Ragione sociale *</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="c-name" /></div>
          <div className="field"><label>Squadra / Società</label><input value={form.team} onChange={(e) => setForm({ ...form, team: e.target.value })} placeholder="es. ASD Aurora Ginnastica" /></div>
          <div className="field"><label>Referente</label><input value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} /></div>
          <div className="field"><label>Email</label><input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
          <div className="field"><label>Telefono</label><input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
          <div className="field full"><label>Indirizzo</label><input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></div>
          <div className="field"><label>Codice fiscale / P.IVA</label><input value={form.tax_code} onChange={(e) => setForm({ ...form, tax_code: e.target.value })} /></div>
          <div className="field full"><label>Note</label><textarea rows="3" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} /></div>
        </div>
      </Modal>
    </Layout>
  );
}
